import { fetchAuthSession } from "@aws-amplify/auth";

/**
 * Get the authentication token for Pusher
 * @returns Promise resolving to the JWT token or null if not available
 */
export const getAuthToken = async (): Promise<string | null> => {
  try {
    const session = await fetchAuthSession();
    const idToken = session.tokens?.idToken?.toString();
    return idToken || null;
  } catch (error) {
    console.error("Failed to retrieve auth token:", error);
    return null;
  }
}; 